<template>
  <button type="button" class="back-chevron" aria-label="Back" @click="goBack">
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M14.5 6l-6 6 6 6" />
    </svg>
  </button>
</template>

<script>
// Standard back control for student portal pages: a black chevron that returns to the
// previous page, or to the dashboard when the page was opened directly.
export default {
  name: 'BackChevron',
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'student-dashboard' });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.back-chevron {
  width: 40px;
  height: 40px;
  padding: 0;
  border: 1px solid #e4e7ea;
  border-radius: 50%;
  background: #ffffff;
  color: #181818;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 1px 2px rgba(20, 28, 40, 0.06);
  transition: background 0.15s ease, border-color 0.15s ease, transform 0.15s ease;

  svg {
    margin-left: -2px;
  }

  &:hover {
    background: #f4f4f5;
    border-color: #d6d9dd;
    transform: translateX(-1px);
  }

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid #181818;
    outline-offset: 2px;
  }
}
</style>
